interface TruncateWalletAddressProps {
  address: string;
  startLength?: number;  // optional with default 6
  endLength?: number;    // optional with default 4
}

export const TruncateWalletAddress = ({
  address,
  startLength = 6,
  endLength = 4
}: TruncateWalletAddressProps): string => {
  if (!address) return '';
  if (address.length <= startLength + endLength) return address;

  return `${address.slice(0, startLength)}...${address.slice(-endLength)}`;
};